import { render, staticRenderFns } from "./DeleteRequestDialog.vue?vue&type=template&id=43040956&scoped=true&"
import script from "./DeleteRequestDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteRequestDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRequestDialog.vue?vue&type=style&index=0&id=43040956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43040956",
  null
  
)

export default component.exports